import {Params} from '../getConfig'

export const amplifyKiwiProduction: Params = {
  aws_user_pools_id: 'eu-west-1_UsdY9Ih0D',
  aws_cognito_identity_pool_id: '', // Not needed for any partner
  aws_user_pools_web_client_id: 'v9mv03h4betb9d4s59ef62bt8',
  oauth_domain: 'kiwi-auth-production.auth.eu-west-1.amazoncognito.com',
  aws_user_files_s3_bucket: '' // Not needed for any partner
}
